import * as actionTypes from './actionTypes'

import dashboardPerformanceTrendAxios from '../../axios/dashboardPerformanceTrend'
import { enqueueSnackbar } from './alert'

// dashboard_performace_trend/structure/dropdown

export const fetchStructureForPerformanceTrend = filterOptions => {
  return dispatch => {
    const params = filterOptions

    dispatch(fetchStructureForPerformanceTrendStart())
    dashboardPerformanceTrendAxios
      .get('/dashboard_performace_trend/structure/dropdown', { params })
      .then(response => {
        dispatch(fetchStructureForPerformanceTrendSuccess(response.data.data))
      })
      .catch(error => {
        if (error?.response) {
          switch (error?.response?.status) {
            case 400:
              dispatch(
                enqueueSnackbar({
                  message: 'Fetch Dashboard Performance Trend Failed',
                  options: {
                    variant: 'error',
                    data: error?.response?.data?.data ?? []
                  }
                })
              )
              break

            default:
              dispatch(
                enqueueSnackbar({
                  message: error?.response?.data?.message || '',
                  options: {
                    variant: 'error'
                  }
                })
              )
              break
          }
        }
        dispatch(fetchStructureForPerformanceTrendFailed())
      })
  }
}

export const fetchStructureForPerformanceTrendStart = () => {
  return {
    type: actionTypes.FETCH_STRUCTURE_OPTION_FOR_PERFORMANCE_TREND_START
  }
}

export const fetchStructureForPerformanceTrendSuccess = data => {
  return {
    type: actionTypes.FETCH_STRUCTURE_OPTION_FOR_PERFORMANCE_TREND_SUCCESS,
    data
  }
}

export const fetchStructureForPerformanceTrendFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_STRUCTURE_OPTION_FOR_PERFORMANCE_TREND_FAILED,
    errorMessage
  }
}

// dashboard_performace_trend/item/dropdown

export const fetchItemForPerformanceTrend = filterOptions => {
  return dispatch => {
    const params = filterOptions

    dispatch(fetchItemForPerformanceTrendStart())
    dashboardPerformanceTrendAxios
      .get('/dashboard_performace_trend/item/dropdown', { params })
      .then(response => {
        dispatch(fetchItemForPerformanceTrendSuccess(response.data.data))
      })
      .catch(error => {
        dispatch(fetchItemForPerformanceTrendFailed(error))
      })
  }
}

export const fetchItemForPerformanceTrendStart = () => {
  return {
    type: actionTypes.FETCH_ITEM_OPTIONS_FOR_PERFORMANCE_TREND_START
  }
}

export const fetchItemForPerformanceTrendSuccess = data => {
  return {
    type: actionTypes.FETCH_ITEM_OPTIONS_FOR_PERFORMANCE_TREND_SUCCESS,
    data
  }
}

export const fetchItemForPerformanceTrendFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_ITEM_OPTIONS_FOR_PERFORMANCE_TREND_FAILED,
    errorMessage
  }
}

// ​dashboard_performace_trend​/chart

export const fetchDashboardPerformanceTrendChart = filterOptions => {
  return dispatch => {
    const params = filterOptions
    dispatch(fetchDashboardPerformanceTrendChartStart())
    dashboardPerformanceTrendAxios
      .get('/dashboard_performace_trend/chart', { params })
      .then(response => {
        dispatch(fetchDashboardPerformanceTrendChartSuccess(response.data.data))
      })
      .catch(error => {
        dispatch(fetchDashboardPerformanceTrendChartFailed(error))
      })
  }
}

export const fetchDashboardPerformanceTrendChartStart = () => {
  return {
    type: actionTypes.FETCH_DASHBOARD_PERFORMANCE_TREND_CHART_START
  }
}

export const fetchDashboardPerformanceTrendChartSuccess = data => {
  return {
    type: actionTypes.FETCH_DASHBOARD_PERFORMANCE_TREND_CHART_SUCCESS,
    data
  }
}

export const fetchDashboardPerformanceTrendChartFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_DASHBOARD_PERFORMANCE_TREND_CHART_FAILED,
    errorMessage
  }
}

// ​dashboard_performace_trend/all

export const fetchDashboardPerformanceTrendAll = filterOptions => {
  return dispatch => {
    const params = filterOptions

    dispatch(fetchDashboardPerformanceTrendAllStart())
    dashboardPerformanceTrendAxios
      .get('/dashboard_performace_trend/all', { params })
      .then(response => {
        dispatch(fetchDashboardPerformanceTrendAllSuccess(response.data.data))
      })
      .catch(error => {
        dispatch(fetchDashboardPerformanceTrendAllFailed(error))
      })
  }
}

export const fetchDashboardPerformanceTrendAllStart = () => {
  return {
    type: actionTypes.FETCH_DASHBOARD_PERFORMANCE_TREND_ALL_START
  }
}

export const fetchDashboardPerformanceTrendAllSuccess = data => {
  return {
    type: actionTypes.FETCH_DASHBOARD_PERFORMANCE_TREND_ALL_SUCCESS,
    data
  }
}

export const fetchDashboardPerformanceTrendAllFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_DASHBOARD_PERFORMANCE_TREND_ALL_FAILED,
    errorMessage
  }
}

// api/dropdown/employee_detail

export const fetchEmpDetailOptions = filterOptions => {
  let params = filterOptions

  return dispatch => {
    dispatch(fetchEmpDetailOptionsStart())
    dashboardPerformanceTrendAxios
      .get('/dropdown/employee_detail', { params })
      .then(response => {
        dispatch(fetchEmpDetailOptionsSuccess(response.data.data))
      })
      .catch(error => {
        dispatch(fetchEmpDetailOptionsFailed(error))
      })
  }
}

export const fetchEmpDetailOptionsStart = () => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_DETAIL_OPTIONS_START
  }
}

export const fetchEmpDetailOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_DETAIL_OPTIONS_SUCCESS,
    data
  }
}

export const fetchEmpDetailOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_EMPLOYEE_DETAIL_OPTIONS_FAILED,
    errorMessage
  }
}

// api/dropdown/company

export const fetchCompanyOptions = filter => {
  return dispatch => {
    dispatch(fetchCompanyOptionsStart())
    dashboardPerformanceTrendAxios
      .get('/dropdown/company', { filter })
      .then(response => {
        if (response.status === 200) {
          dispatch(fetchCompanyOptionsSuccess(response.data.data))
        }
      })
      .catch(error => {
        dispatch(fetchCompanyOptionsFailed(error))
      })
  }
}

export const fetchCompanyOptionsStart = () => {
  return {
    type: actionTypes.FETCH_COMPANY_OPTIONS_START
  }
}

export const fetchCompanyOptionsSuccess = data => {
  return {
    type: actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS,
    data
  }
}

export const fetchCompanyOptionsFailed = errorMessage => {
  return {
    type: actionTypes.FETCH_COMPANY_OPTIONS_FAILED,
    errorMessage
  }
}
